const Layouts = {
  CROSS_REFERENCE_BANNER: 'Cross-Reference Banner',
  STATISTIC_TILE: 'Statistic Tile',
  HORIZONTAL_RIGHT_IMAGE: 'Horizontal Right Image',
  HORIZONTAL_LEFT_IMAGE: 'Horizontal Left Image',
  FULL_WIDTH: 'Full Width',
  GALLERY_TILE: 'Gallery Tile',
  ACCORDION: 'Accordion',
  VERTICAL_TILE: 'Vertical Tile',
} as const;

export type Layout = (typeof Layouts)[keyof typeof Layouts];

export default Layouts;
